import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const readAloudEffect: BlogMetaData = {
  title: '読み聞かせに期待できる効果は？研究とモンテッソーリ式の絵本選び',
  description:
    '読み聞かせに期待できる効果と限界を、共有読書と単語学習・言語発達の研究をもとに解説。研究結果とモンテッソーリ教育の考え方を分け、絵本選びや繰り返しへの関わり方を紹介します。',
  thumbnailUrl: '/img/blog-read-aloud-effect.webp',
  filePath: buildBlogFilePath('read-aloud-effect'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
